import { createListQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'

export const useFilter = createSharedComposable(() => {
    return createListQuery('filter', [
        { label: 'Show all values (default)', value: 'all' as const },
        {
            label: 'G20 countries',
            value: 'g20' as const
        },
        {
            label: 'Low income',
            value: 'low-income' as const
        },
        {
            label: 'Lower-middle income',
            value: 'lower-mid-income' as const
        },
        {
            label: 'Upper-middle income',
            value: 'upper-mid-income' as const
        },
        {
            label: 'High income',
            value: 'high-income' as const
        },
        { label: 'Top 5', value: 'top-5' as const },
        { label: 'Top 10', value: 'top-10' as const },
        { label: 'Top 20', value: 'top-20' as const },
        { label: 'Bottom 5', value: 'bottom-5' as const },
        { label: 'Bottom 10', value: 'bottom-10' as const },
        { label: 'Bottom 20', value: 'bottom-20' as const }
    ])
})
